// @flow

const CANCEL_SEARCH_CLICK = "request/search/cancel/click";

const REQUEST_ORIGIN_SET = "request/origin/set";
const ORIGIN_SUGGESTION_SET = "request/origin/suggestion/set";
const ORIGIN_DESELECT = "request/origin/deselect";
const ORIGIN_LATLNG_SET = "request/origin/latlng/set";
const ORIGIN_ADDRESS_SET = "request/origin/address/set";
const ORIGIN_LABEL_CLICK = "request/origin/label/click";
const CANCEL_ORIGIN_TERMINALS_CLICK = "request/origin/terminals/cancel/";

const REQUEST_DEST_SET = "request/dest/set";
const DEST_SUGGESTION_SET = "request/dest/suggestion/set";
const DEST_LABEL_CLICK = "request/dest/label/click";
const DEST_LATLNG_SET = "request/dest/latlng/set";
const DEST_ADDRESS_SET = "request/dest/address/set";
const DEST_DESELECT = "request/dest/deselect";
const CANCEL_DEST_TERMINALS_CLICK = "request/dest/terminals/cancel/";

export default {
    REQUEST_ORIGIN_SET,
    REQUEST_DEST_SET,
    ORIGIN_SUGGESTION_SET,
    DEST_SUGGESTION_SET,
    ORIGIN_LABEL_CLICK,
    DEST_LABEL_CLICK,
    CANCEL_SEARCH_CLICK,
    ORIGIN_ADDRESS_SET,
    DEST_ADDRESS_SET,
    DEST_DESELECT,
    ORIGIN_DESELECT,
    CANCEL_ORIGIN_TERMINALS_CLICK,
    CANCEL_DEST_TERMINALS_CLICK,
    ORIGIN_LATLNG_SET,
    DEST_LATLNG_SET,
};



// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentRequest/types.js